import { alpha, createTheme } from '@mui/material/styles';
import '@fontsource/hanken-grotesk';

const fontFamily = ['Hanken Grotesk', 'Helvetica', 'Arial', 'sans-serif'].join(
  ',',
);

const black = '#000000';
const white = '#FFFFFF';
const backgroundPaperDark = '#1E1E1E';

const readerTheme = createTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: '#467A4D',
          dark: '#315535',
          light: '#6B9470',
        },
        secondary: {
          main: '#00509B',
          dark: '#00386C',
          light: '#3373AF',
        },
        text: {
          primary: alpha(black, 0.9),
          secondary: alpha(black, 0.7),
        },
        background: {
          paper: white,
          default: '#FAFAFA',
        },
        action: {
          hover: alpha(black, 0.04),
          active: alpha(black, 0.56),
        },
      },
    },
    dark: {
      palette: {
        primary: {
          main: '#467A4D',
          dark: '#315535',
          light: '#6B9470',
        },
        secondary: {
          main: '#00509B',
          dark: '#00386C',
          light: '#3373AF',
        },
        text: {
          primary: alpha(white, 1),
          secondary: alpha(white, 0.7),
        },
        background: {
          paper: '#161616',
          default: '#121212',
        },
        action: {
          hover: alpha(white, 0.08),
          active: alpha(white, 0.56),
        },
      },
    },
  },
  typography: {
    fontFamily,
  },
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: [
          {
            border: 'none',
            backgroundColor: white,
            boxShadow: 'none',
          },
          ({ theme }) =>
            theme.applyStyles('dark', {
              backgroundColor: backgroundPaperDark,
              boxShadow: 'none',
            }),
        ],
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: ({ theme }) => ({
          minHeight: '56px',
          [theme.breakpoints.up('sm')]: {
            minHeight: '56px',
          },
        }),
      },
    },
    MuiSkeleton: {
      styleOverrides: {
        root: [
          {
            backgroundColor: alpha(black, 0.04),
          },
          ({ theme }) =>
            theme.applyStyles('dark', {
              backgroundColor: alpha(white, 0.08),
            }),
        ],
      },
    },
  },
  shape: {
    borderRadius: 0,
  },
});

readerTheme.typography.h1 = {
  fontSize: readerTheme.typography.pxToRem(24),
  fontWeight: 700,
  lineHeight: '130%',
  [readerTheme.breakpoints.up('md')]: {
    fontSize: readerTheme.typography.pxToRem(36),
  },
};

readerTheme.typography.h2 = {
  fontSize: readerTheme.typography.pxToRem(20),
  fontWeight: 700,
  lineHeight: '130%',
  [readerTheme.breakpoints.up('md')]: {
    fontSize: readerTheme.typography.pxToRem(26),
  },
};

readerTheme.typography.h3 = {
  fontSize: readerTheme.typography.pxToRem(18),
  fontWeight: 700,
  lineHeight: '130%',
  [readerTheme.breakpoints.up('md')]: {
    fontSize: readerTheme.typography.pxToRem(20),
  },
};

readerTheme.typography.h4 = {
  fontSize: readerTheme.typography.pxToRem(16),
  fontWeight: 700,
  lineHeight: '130%',
  [readerTheme.breakpoints.up('md')]: {
    fontSize: readerTheme.typography.pxToRem(18),
  },
};

readerTheme.typography.h5 = {
  fontSize: readerTheme.typography.pxToRem(14),
  fontWeight: 700,
  lineHeight: '130%',
  [readerTheme.breakpoints.up('md')]: {
    fontSize: readerTheme.typography.pxToRem(16),
  },
};

readerTheme.typography.h6 = {
  fontSize: readerTheme.typography.pxToRem(12),
  fontWeight: 700,
  lineHeight: '130%',
  [readerTheme.breakpoints.up('md')]: {
    fontSize: readerTheme.typography.pxToRem(14),
  },
};

readerTheme.typography.subtitle1 = {
  fontSize: readerTheme.typography.pxToRem(16),
  fontWeight: 600,
  lineHeight: '150%',
  [readerTheme.breakpoints.up('md')]: {
    fontSize: readerTheme.typography.pxToRem(18),
  },
};

readerTheme.typography.subtitle2 = {
  fontSize: readerTheme.typography.pxToRem(14),
  fontWeight: 600,
  lineHeight: '150%',
  [readerTheme.breakpoints.up('md')]: {
    fontSize: readerTheme.typography.pxToRem(16),
  },
};

readerTheme.typography.body1 = {
  fontSize: readerTheme.typography.pxToRem(16),
  fontWeight: 400,
  lineHeight: '150%',
  [readerTheme.breakpoints.up('md')]: {
    fontSize: readerTheme.typography.pxToRem(18),
  },
};

readerTheme.typography.body2 = {
  fontSize: readerTheme.typography.pxToRem(14),
  fontWeight: 400,
  lineHeight: '150%',
  [readerTheme.breakpoints.up('md')]: {
    fontSize: readerTheme.typography.pxToRem(16),
  },
};

readerTheme.typography.caption = {
  fontSize: readerTheme.typography.pxToRem(12),
  fontWeight: 500,
  lineHeight: '150%',
  [readerTheme.breakpoints.up('md')]: {
    fontSize: readerTheme.typography.pxToRem(14),
  },
};

readerTheme.typography.overline = {
  fontSize: readerTheme.typography.pxToRem(10),
  fontWeight: 700,
  lineHeight: '150%',
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
  [readerTheme.breakpoints.up('md')]: {
    fontSize: readerTheme.typography.pxToRem(12),
  },
};
export default readerTheme;
